export default function ResetPasswordModal({
  oldPassword,
  onOldPasswordChange,
  newPassword,
  onNewPasswordChange,
  onCloseButtonClick,
  onSaveButtonClick,
  isLoading,
  warning
}) {
  return (
    <div className="modal-overlay">
      <div className="modal profile-modal">
        <h3>Reset Password</h3>
        <div className="header-input-container">
          <label htmlFor="old-password">Input Old Password</label>
          <input 
            type="text"
            name="old-password"
            id="old-password"
            value={oldPassword}
            onChange={onOldPasswordChange}
          />
          {
            warning?.old_pass && <span className="profile-warning">{warning.old_pass}</span>
          }
        </div>
        <div className="header-input-container">
          <label htmlFor="new-password">Input New Password</label>
          <input 
            type="text"
            name="new-password"
            id="new-password"
            value={newPassword}
            onChange={onNewPasswordChange}
          />
          {
            warning?.new_pass && <span className="profile-warning">{warning.new_pass}</span>
          }
        </div>
        <div className="header-modal-buttons-row">
          <button className="button-grey" onClick={onCloseButtonClick}>Cancel</button>
          <button className={`button-blue ${isLoading ? 'loading' : ''}`} onClick={onSaveButtonClick}>
            {!isLoading && 'Save'}
          </button>
        </div>
      </div>
    </div>
  );
};
